/****************************************************************************************
 * Copyright (c) 2023. Peter Lemke, SV-Studios                                          *
 * This File, its contents and by extension the corresponding project is property of    *
 * SV-Studios and may not be used without explicit permission to do so.                 *
 *                                                                                      *
 * management@sv-studios.net                                                            *
 ****************************************************************************************/

import { createSlice } from "@reduxjs/toolkit";

const initialMiniSidenav = sessionStorage.getItem("miniSidenav") === "true";
const initialExpertMode = localStorage.getItem("expertMode") === "true";
let initialDarkMode;
const manualDarkMode = localStorage.getItem("darkMode");
if (!manualDarkMode) {
  initialDarkMode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
} else {
  initialDarkMode = manualDarkMode === "true";
}

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    miniSidenav: initialMiniSidenav,
    tempMiniSidenav: true,
    transparentSidenav: false,
    whiteSidenav: false,
    darkMode: initialDarkMode,
    expertMode: false,
    fixedNavbar: false,
    transparentNavbar: false,
    openConfigurator: false,
    showModuleIcons: true,
    layout: "dashboard",
  },
  reducers: {
    setMiniSidenav(state, action) {
      state.miniSidenav = action.payload;
      sessionStorage.setItem("miniSidenav", String(action.payload));
    },
    setTempMiniSidenav(state, action) {
      state.tempMiniSidenav = action.payload;
      state.miniSidenav = action.payload;
    },
    setTransparentSidenav(state, action) {
      state.transparentSidenav = action.payload;
    },

    setWhiteSidenav(state, action) {
      state.whiteSidenav = action.payload;
    },
    setDarkMode(state, action) {
      state.darkMode = action.payload;
      localStorage.setItem("darkMode", String(action.payload));
    },
    setExpertMode(state, action) {
      state.expertMode = action.payload;
      localStorage.setItem("expertMode", String(action.payload));
    },
    setFixedNavbar(state, action) {
      state.fixedNavbar = action.payload;
    },
    setTransparentNavbar(state, action) {
      state.transparentNavbar = action.payload;
    },
    setOpenConfigurator(state, action) {
      state.openConfigurator = action.payload;
    },
    setLayout(state, action) {
      state.layout = action.payload;
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice;
